import CONFIGURATOR_TYPES from '../../_flux/constants/configurator_types';
export function allowVehicleConfiguratorOnStore(currentStore)
{
    return (['AU', 'AU_SCA', 'AU_NRMA', 'NZ', 'NZ_SCA'].indexOf(currentStore) >= 0);
}

export function configuratorSourceIsRegoOrVehicle(configuratorSource) {
    return [
        CONFIGURATOR_TYPES.VEHICLE_CONFIGURATOR,
        CONFIGURATOR_TYPES.REGO_LOOKUP
    ].indexOf(configuratorSource) >= 0;
}

export function isNzStore(currentStore) {
    return (['NZ', 'NZ_SCA'].indexOf(currentStore) >= 0);
}

export function isConfiguratorMotoTyreEnabled()
{
    return TYROOLA.globals.configuratorMotoTyreEnabled;
}